(function () {
  'use strict';

  // Read old markers only for migration, then remove them from the cart.
  var ownerAttribute = '_Delivery Preferences Owner';
  var overrideAttribute = '_Delivery Preferences Override';
  var orderStorageKey = 'trd_delivery_order_preferences';

  function normalise(value) {
    value = value && typeof value === 'object' ? value : {};
    return {
      quickDropOff: value.quickDropOff === true,
      safePlace: ['Behind bins', 'Outhouse / shed', 'Other safe place'].indexOf(value.safePlace) >= 0 ? value.safePlace : '',
      notes: typeof value.notes === 'string' ? value.notes.slice(0, 500) : ''
    };
  }

  function fromAttributes(attributes) {
    return normalise({
      quickDropOff: attributes['Delivery Quick drop-off'] === 'Yes',
      safePlace: attributes['Delivery Safe place'],
      notes: attributes['Delivery Notes']
    });
  }

  window.TRDDeliveryPreferenceAccount = function (options) {
    var scope = '';
    var cartToken = '';
    var overridden = false;
    var ready = !options.loggedIn;
    var pending = null;
    var loadedPreferences = null;

    function readStored(key) {
      var local = null;
      var session = null;
      try { local = JSON.parse(localStorage.getItem(key)); } catch (error) {}
      try { session = JSON.parse(sessionStorage.getItem(key)); } catch (error) {}
      if (session && (!local || (session._savedAt || 0) >= (local._savedAt || 0))) return session;
      return local;
    }

    function store(key, value) {
      var serialized = JSON.stringify(Object.assign({}, value, { _savedAt: Date.now() }));
      try {
        localStorage.setItem(key, serialized);
        try { sessionStorage.removeItem(key); } catch (error) {}
        return;
      } catch (error) {}
      try { sessionStorage.setItem(key, serialized); } catch (error) {}
    }

    return {
      get ready() { return ready; },
      get overridden() { return overridden; },
      defaults: function () { return normalise(JSON.parse(options.defaults || 'null')); },
      accept: function () { ready = true; },
      resetOrder: function () {
        overridden = false;
        var stored = readStored(orderStorageKey);
        if (stored && stored.scope === options.scope) {
          try { localStorage.removeItem(orderStorageKey); } catch (error) {}
          try { sessionStorage.removeItem(orderStorageKey); } catch (error) {}
        }
      },
      guestPreferences: function () {
        // Cart notes alone cannot prove ownership after logout. Guests use only
        // their guest-specific browser preferences, never an account's cart notes.
        return normalise(readStored('saved_delivery_preferences'));
      },
      ensure: function () {
        if (ready) return Promise.resolve(null);
        if (loadedPreferences !== null) return Promise.resolve(loadedPreferences);
        if (pending) return pending;
        pending = (async function () {
          var controller = new AbortController();
          var timeout = setTimeout(function () { controller.abort(); }, 12000);
          try {
            // Shopify renders only the signed-in customer's own metafield into Liquid.
            // These defaults are read-only here; only the account editor can change them.
            if (typeof options.scope !== 'string' || !options.scope) throw new Error('Unable to load account delivery preferences.');
            var defaults = JSON.parse(options.defaults || 'null');
            var response = await fetch(options.root + 'cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' }, signal: controller.signal });
            if (!response.ok) throw new Error('Unable to load delivery preferences for this order.');
            var cart = await response.json();
            scope = options.scope;
            cartToken = String(cart.token || '');
            var attributes = cart.attributes || {};
            var stored = readStored(orderStorageKey);
            var preferences = normalise(defaults);
            if (cartToken && stored && stored.scope === scope && stored.cartToken === cartToken) {
              preferences = normalise(stored.preferences);
              overridden = true;
            } else if (attributes[ownerAttribute] === scope && attributes[overrideAttribute] === 'Yes') {
              // Carry an existing order override into browser storage once.
              preferences = fromAttributes(attributes);
              overridden = true;
              if (cartToken) store(orderStorageKey, { scope: scope, cartToken: cartToken, preferences: preferences });
            }
            loadedPreferences = preferences;
            return preferences;
          } finally {
            clearTimeout(timeout);
            pending = null;
          }
        })();
        return pending;
      },
      change: function (preferences) {
        if (!ready) return;
        preferences = normalise(preferences);
        if (options.loggedIn) {
          overridden = true;
          if (cartToken) store(orderStorageKey, { scope: scope, cartToken: cartToken, preferences: preferences });
        } else {
          store('saved_delivery_preferences', preferences);
        }
      },
      attributes: function () {
        var attributes = {};
        // Shopify copies cart attributes into the order's Additional details.
        // Account ownership and override state must stay in browser storage.
        attributes[ownerAttribute] = '';
        attributes[overrideAttribute] = '';
        return attributes;
      }
    };
  };
})();
